export default __webpack_public_path__ + "static/media/500_ml_e.79bc5443.svg";